import React from "react";

function InfoCard({ label, value }) {
  return (
    <div className="border border-gray-200 dark:border-neutral-700 rounded-xl p-3 bg-white dark:bg-neutral-950">
      <div className="text-xs text-gray-500 dark:text-gray-400">{label}</div>
      <div className="font-medium text-black dark:text-white break-words">
        {value || "-"}
      </div>
    </div>
  );
}

function StatusBadge({ value }) {
  const map = {
    active:
      "bg-green-50 text-green-700 border-green-200 dark:bg-green-950/30 dark:text-green-300 dark:border-green-900",
    inactive:
      "bg-yellow-50 text-yellow-700 border-yellow-200 dark:bg-yellow-950/30 dark:text-yellow-300 dark:border-yellow-900",
    archived:
      "bg-red-50 text-red-700 border-red-200 dark:bg-red-950/30 dark:text-red-300 dark:border-red-900",
  };

  return (
    <span
      className={`inline-flex px-2.5 py-1 rounded-full text-xs font-medium border ${
        map[value] ||
        "bg-gray-50 text-gray-700 border-gray-200 dark:bg-neutral-800 dark:text-gray-300 dark:border-neutral-700"
      }`}
    >
      {value || "-"}
    </span>
  );
}

function getPersonName(person) {
  return (
    person?.full_name ||
    person?.display_name ||
    `${person?.first_name || ""} ${person?.last_name || ""}`.trim() ||
    "Unnamed person"
  );
}

export default function HRPersonHeader({
  person,
  activeEmployment,
  onAddEmployment,
  onAddDocument,
  onAddRole,
  onCloseEmployment,
}) {
  if (!person) return null;

  return (
    <div className="bg-white dark:bg-neutral-900 rounded-2xl border border-gray-200 dark:border-neutral-700 shadow-sm p-6">
      <div className="flex flex-col xl:flex-row xl:items-start xl:justify-between gap-6">
        <div className="min-w-0">
          <h1 className="text-2xl font-bold text-black dark:text-white">
            {getPersonName(person)}
          </h1>

          <div className="mt-2 flex flex-wrap items-center gap-2">
            <span className="text-sm text-gray-600 dark:text-gray-300">
                {person?.position_title || "-"}
            </span>
            <span className="text-gray-400">•</span>
            <span className="text-sm text-gray-600 dark:text-gray-300 capitalize">
                {person?.person_type || "-"}
            </span>
            <StatusBadge value={person?.status} />
          </div>

          <div className="text-sm text-gray-500 dark:text-gray-400 mt-2">
                {person?.department_name || "-"} / {person?.team_name || "-"}
            </div>
        </div>

        <div className="flex flex-wrap gap-3 xl:justify-end">
          <button
            onClick={onAddEmployment}
            className="px-4 py-2 rounded-xl bg-black text-white"
          >
            Add employment
          </button>

          <button
            onClick={onAddDocument}
            className="px-4 py-2 rounded-xl border border-gray-300 dark:border-neutral-700 bg-white dark:bg-neutral-950 text-black dark:text-white"
          >
            Add document
          </button>

          <button
            onClick={onAddRole}
            className="px-4 py-2 rounded-xl border border-gray-300 dark:border-neutral-700 bg-white dark:bg-neutral-950 text-black dark:text-white"
          >
            Add role
          </button>

          {activeEmployment && Number(activeEmployment.active_flag) === 1 && (
            <button
              onClick={() => onCloseEmployment?.(activeEmployment)}
              className="px-4 py-2 rounded-xl border border-red-300 text-red-700 bg-red-50 dark:bg-red-950/30 dark:text-red-300 dark:border-red-900"
            >
              Close active employment
            </button>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3 mt-6">
        <InfoCard label="Employee code" value={person.employee_code} />
        <InfoCard label="Work email" value={person.email_work} />
        <InfoCard label="Mobile phone" value={person.phone_mobile} />
        <InfoCard label="Manager" value={person?.manager_name} />
        <InfoCard label="Legal entity" value={activeEmployment?.legal_entity} />
        <InfoCard label="Office location" value={activeEmployment?.office_location} />
        <InfoCard label="Work mode" value={activeEmployment?.work_mode} />
        <InfoCard label="Start date" value={activeEmployment?.start_date} />
      </div>
    </div>
  );
}